import i18n, { COMMON_NAMESPACE } from '@/i18n';

const CONSENT_UPDATED_AT_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
};

export function formatConsentVersionDisplay(version: string): string {
  return i18n.t('versionLabel', {
    ns: COMMON_NAMESPACE,
    version,
  });
}

export function formatConsentUpdatedAtDisplay(updatedAt: string): string {
  const date = new Date(updatedAt);
  if (Number.isNaN(date.getTime())) {
    throw new Error(`Invalid consent updatedAt: ${updatedAt}`);
  }
  return new Intl.DateTimeFormat(i18n.language, CONSENT_UPDATED_AT_FORMAT).format(
    date,
  );
}
